import { detect } from "detect-browser";

function checkOS(os) {
  const browser = detect();
  return browser.os.includes(os);
}

export function getBrowser() {
  const browser = detect();
  return browser.name;
}

export function isAndroid() {
  return !checkOS("Windows");
}

export function isIOS() {
  return checkOS("iOS");
}

export function callAndroidApp(request) {
  let url = "intent://dx.principal.com#Intent;scheme=http;package=principal.com.authentication_bridge;";
  url += `S.txId=${request.txId ? request.txId : ""};`;
  url += `S.traceId=${request.traceId ? request.traceId : ""};`;
  if (request.kongClientId) {
    url += `S.kongClientId=${request.kongClientId};`;
  }
  if (request.kongClientSecret) {
    url += `S.kongClientSecret=${request.kongClientSecret};`;
  }
  if (request.company) {
    url += `S.company=${request.company};`;
  }
  if (request.userId) {
    url += `S.userId=${request.userId};`;
  }
  if (request.otiMode) {
    url += "S.otiMode=true;";
  }
  return `${url}end`;
}

export function sanitizeUrl(url) {
  const SAFE_URL_PATTERN = new RegExp(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/g);
  const sanitizedUrl = String(url).trim();
  if (sanitizedUrl === "null" || sanitizedUrl.length === 0 || sanitizedUrl === "about:blank") {
    return "about:blank";
  } else if (!SAFE_URL_PATTERN.test(sanitizedUrl)) {
    return null;
  } else {
    return sanitizedUrl;
  }
}
